import * as React from "react";
import * as styles from "../block/block.module.scss";

/**
 * @type {Object} 「UI:atoms - ブロック 記事カード アーカイブ一覧 サイドバー用 コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {String} url slugを受け取るための引数です。
 * @param {Object} children 子コンポーネントを受け取るための引数です。任意の要素を渡します。
 * @param {String} title 記事タイトルを受け取るための引数です。
 *
 */

const ArticleCardSidebar = ({ url, title, children }) => {
  return (
    <a href={url} className={`${styles.articleCard} ${styles.sidebar}`}>
      <article>
        {children}
        {title !== null && <h3>{title}</h3>}
      </article>
    </a>
  );
};

export default ArticleCardSidebar;
